// Tiny dev-only logger so warnings never appear in production console
const DEV = process.env.NODE_ENV !== "production";

export const devWarn = DEV ? console.warn.bind(console) : () => {};
export const devError = DEV ? console.error.bind(console) : () => {};
